import { CommonModule, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localePtExtra from '@angular/common/locales/extra/pt';
import localePt from '@angular/common/locales/pt';
import {
  isDevMode,
  LOCALE_ID,
  NgModule,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHotToastConfig } from '@ngneat/hot-toast';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import {
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  includeBearerTokenInterceptor,
  provideKeycloak,
} from 'keycloak-angular';
import { provideEnvironmentNgxMask } from 'ngx-mask';

import { App } from './app';
import { AppRoutingModule } from './app-routing-module';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { keycloakConfig } from './core/keycloak/keycloak.init';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localePt, 'pt-BR', localePtExtra);

@NgModule({
  declarations: [App],
  imports: [BrowserModule, CommonModule, AppRoutingModule, SharedModule],
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([apiInterceptor, includeBearerTokenInterceptor]),
    ),
    provideRouter([], withComponentInputBinding()),
    provideStore({ router: routerReducer }),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: true,
      traceLimit: 75,
      connectInZone: true,
    }),
    provideRouterStore(),
    provideEnvironmentNgxMask(),
    provideHotToastConfig({
      position: 'top-center',
      duration: 4000,
      dismissible: true,
      theme: 'toast',
    }),
    provideKeycloak(keycloakConfig),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [{ urlPattern: /^((?!\/assets).)*$/i }],
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'pt-BR',
    },
    DateFnsAdapter,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ],
  bootstrap: [App],
})
export class AppModule {}
